module.exports = __webpack_public_path__ + "img/tips.e232f7e2.png";